<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="450" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Add new payment terms
      v-spacer
      v-btn(icon @click="handleCloseDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      v-form(ref="form")
        div.text-sm.font-semibold.neutral700--text.mt-4 How many days would you like for your payment terms?
        v-text-field.text-sm.mt-2.round-xl(v-model.number="noOfDay" placeholder="Enter days" outlined dense height="48" hide-details="auto" type="number" :rules="rules.not_empty_or_zero" suffix="days" @keypress="isInteger($event)")
    v-card-actions.pb-4.pt-3.px-6
      v-btn.button-md.neutral700--text.underline.mr-2(text @click="handleCloseDialog") Cancel
      v-spacer
      v-btn.button-md(:loading="isLoading" color="primary" depressed @click="handleAddData") Add
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      noOfDay: null,
      rules: {
        not_empty_or_zero: [v => !!v || v === 0 || 'This field is required', v => v > 0 || 'Must be greater than 0'],
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    isInteger(evt) {
      evt = (evt) || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    handleAddData () {
      if (!this.$refs.form.validate()) return
      this.isFetching = true
      let data = {
        company: this.company.id,
        field: 'purchase.payment_term',
        value: this.noOfDay,
        enabled: true,
      }
      this.$axios.post('/options', data)
        .then(() => {
          this.$emit('updated')
          this.showMessage(['success', 'Successfully added new payment term'])
          this.handleCloseDialog()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleCloseDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>